import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TRC_CONTENT from '@/constants/trcContentType';

const VideoTags = ({ tags = [], type = '' }) => {
	return (
		<div className="tag-section">
			{[...tags]
				?.sort((a, b) => (a?.priority ?? 0) - (b?.priority ?? 0))
				?.map(tag => {
					const tagId = tag?._id || tag?.id || '';
					const url =
						type === TRC_CONTENT?.TRC
							? `/trc/view-all?tag=${tagId}`
							: `/AllVideos?tag=${tagId}`;

					const tagColor = tag?.color ?? '#ccc';

					return (
						<li
							className="tag-container"
							key={tagId || Math.random()}
							style={{ background: tagColor, color: 'white' }}
						>
							<Link to={url} style={{ color: 'white' }}>{tag?.name ?? 'Untitled'}</Link>
						</li>
					);
				})}
		</div>
	);
};

VideoTags.propTypes = {
	tags: PropTypes.arrayOf(
		PropTypes.shape({
			_id: PropTypes.string,
			id: PropTypes.string,
			name: PropTypes.string,
			color: PropTypes.string,
			priority: PropTypes.number,
		})
	),
	type: PropTypes.string,
};

VideoTags.defaultProps = {
	tags: [],
	type: '',
};

export default VideoTags;

